import { render, staticRenderFns } from "./PerformanceAnalysis.vue?vue&type=template&id=2a4258ef&scoped=true&"
import script from "./PerformanceAnalysis.vue?vue&type=script&lang=js&"
export * from "./PerformanceAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceAnalysis.vue?vue&type=style&index=0&id=2a4258ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4258ef",
  null
  
)

export default component.exports